import type { HelpContent } from './entries.tr';

/**
 * Faz 8 (finans ve analitik) yardım kayıtları — Türkçe. `entries.tr.ts`'e tek satırla eklenir (ADR-801).
 */
const R = 'docs/faz-8/REPORTS_FINANCE_TR.md';
const P = 'docs/faz-8/PURCHASING_TR.md';

export const HELP_FAZ8_TR = {
  'page.sales_report': {
    kind: 'page',
    title: 'Satış raporu',
    short:
      'Seçtiğiniz dönemin satışları: sipariş, net satış, ortalama sepet, iade ve iptal, yeni ve tekrar eden müşteri.',
    whatItDoes:
      'Dönemde verilip kesinleşen siparişlerden (ödendi, hazırlanıyor, kargoda, teslim edildi, tamamlandı) hesaplar. Ödeme bekleyen siparişler satışa sayılmaz, ayrıca bilgi olarak yazılır. Tutarlar TL ve KDV dahildir; KDV hariç net ayrıca gösterilir. Önceki aynı uzunluktaki dönemle karşılaştırır; ürün, kategori, marka, kanal, mağaza, ülke ve ödeme yöntemi kırılımı verir. Tahmini veya örnek rakam gösterilmez.',
    whenToUse: 'Gün sonu, hafta ve ay kapanışında; kampanya veya fiyat değişikliğinin etkisini görmek için.',
    requiredPermission:
      'Satış raporları. Bayi kapsamı sınırlı temsilci yalnızca kendi bayilerinin siparişlerini görür.',
    reversible: 'Rapor yalnızca okur; hiçbir veriyi değiştirmez.',
    commonErrors: [
      {
        problem: 'Rakam sipariş listesindeki toplamdan farklı.',
        solution:
          'Rapor ödeme bekleyen ve hiç kesinleşmeden iptal edilen siparişleri saymaz; iade ve iptali düşer. Sipariş listesinde aynı süzgeçleri seçip karşılaştırın.',
      },
      {
        problem: 'Geçen ayın net satışı değişti.',
        solution:
          'İade ve iptaller siparişin verildiği döneme yazılır; geçen ayın siparişi bugün iade edildiyse geçen ayın net satışı azalır.',
      },
    ],
    guideUrl: `${R}#satis-raporu`,
  },
  'reports.period': {
    kind: 'field',
    title: 'Dönem',
    short:
      'Raporun kapsadığı günler (Türkiye saatiyle, başlangıç ve bitiş dahil). Önceki dönem aynı uzunlukta, hemen öncesidir.',
    whatItDoes:
      'Günlük gruplamada en çok 1 yıl, haftalıkta 2 yıl, aylık ve yıllıkta 5 yıl seçilebilir. Bitiş bugünse dönem tamamlanmamış sayılır.',
    guideUrl: `${R}#donem`,
  },
  'reports.interval': {
    kind: 'field',
    title: 'Gruplama',
    short: 'Grafik ve dönem tablosunun gün, hafta (pazartesi başlar), ay veya yıl olarak toplanması.',
    guideUrl: `${R}#donem`,
  },
  'reports.download': {
    kind: 'action',
    title: 'Dosya indir',
    short: 'Ekrandaki raporu CSV (Türkçe Excel) veya Excel (XLSX) olarak indirir.',
    dataChanged: 'Hiçbir veri değişmez.',
    requiredPermission: 'Raporu görme yetkisi.',
  },
  'sales_report.store': {
    kind: 'field',
    title: 'Mağaza',
    short:
      'Yalnızca seçilen mağazanın siparişleri. Mağaza kapsamı sınırlı kullanıcı yalnızca yetkili mağazaları görür.',
  },
  'sales_report.channel': {
    kind: 'field',
    title: 'Kanal',
    short: 'Siparişin geldiği yer: web mağazası, bayi portalı, panelden açılan sipariş veya API.',
  },
  'sales_report.segment': {
    kind: 'field',
    title: 'Müşteri türü',
    short: 'Perakende (firması olmayan) veya bayi (firma adına verilen) siparişler.',
  },
  'sales_report.summary': {
    kind: 'field',
    title: 'Brütten nete',
    short:
      'Ürün brüt satışından indirimler düşülür, kargo geliri eklenir (sipariş tutarı); iade ve iptal düşülerek net satışa varılır.',
    whatItDoes:
      'İade ve iptal düşümü, iptal edilen ve iade edilen tutardan büyük olanıdır. KDV hariç net, net satışın siparişteki KDV oranıyla ayrılmış hâlidir.',
    guideUrl: `${R}#tanimlar`,
  },
  'sales_report.new_customers': {
    kind: 'field',
    title: 'Yeni ve tekrar eden müşteri',
    short:
      'Yeni müşteri: dönemdeki siparişi, aynı hesabın veya aynı e-postanın kesinleşmiş ilk siparişi olan müşteri. Diğerleri tekrar eden.',
    guideUrl: `${R}#tanimlar`,
  },
  'sales_report.breakdown': {
    kind: 'field',
    title: 'Kırılım',
    short:
      'Net satışın ürün, seçenek, kategori, marka, ülke, kanal, mağaza, müşteri türü veya ödeme yöntemine göre dağılımı.',
    whatItDoes:
      'Ürün, seçenek, kategori ve marka kırılımı satır tutarlarından hesaplanır (kargo hariç); birden çok kategorideki ürün her kategorisinde sayılır.',
    guideUrl: `${R}#kirilim`,
  },
  'dashboard.sales': {
    kind: 'field',
    title: 'Satış özeti',
    short:
      'Bugünün ve son 30 günün net satışı ile sipariş sayısı; dünle ve önceki 30 günle karşılaştırma. Ayrıntı satış raporunda.',
    whatItDoes:
      'Satış raporuyla aynı tanımları kullanır: yalnızca kesinleşmiş siparişler sayılır, iade ve iptal düşülür, tutarlar TL ve KDV dahildir.',
    requiredPermission: 'Satış raporları.',
    guideUrl: `${R}#satis-raporu`,
  },
  'page.finance_inputs': {
    kind: 'page',
    title: 'Finans girdileri',
    short:
      'Kâr hesabında kullanılan maliyetler: ödeme komisyonu kuralları, kargo maliyetleri ve işletme giderleri.',
    whatItDoes:
      'Ödeme kuruluşlarının kesintisi ve kargo firmasına ödenen tutar sistemde kendiliğinden oluşmaz; burada girilir. Komisyon, sözleşmedeki orana göre her ödemeye hesaplanır. Kargo maliyeti gönderi başına elle ya da kargo faturası dosyasından girilir; girilmeyen gönderi için tahmin kuralları kullanılır ve "tahmini" yazılır. İşletme giderleri net kâr ve nakit akışına yansır. Girilmeyen kalem raporda "veri yok" görünür; sistem tahmin uydurmaz.',
    whenToUse: 'Kurulumda bir kez (oranlar ve fiyat listesi), sonra her ay kargo faturası ve giderler için.',
    requiredPermission: 'Görmek: finans raporları. Değiştirmek: finans girdilerini yönetme.',
    reversible: 'Evet: kayıtlar düzenlenip silinebilir; her değişiklik denetim kaydına yazılır.',
    guideUrl: `${R}#finans-girdileri`,
  },
  'finance_inputs.fee_rule': {
    kind: 'field',
    title: 'Ödeme komisyonu kuralı',
    short:
      'Ödeme yöntemi (ve isteğe bağlı taksit sayısı) için oran ve işlem başına sabit ücret, geçerlilik tarihleriyle.',
    whatItDoes:
      'Bir ödemeye, ödeme günü geçerli olan kural uygulanır: taksite özel kural genel kurala, aynı türde en yeni başlangıçlı kural eskisine üstün gelir. Komisyon = tutar × oran + sabit ücret. Kapıda ödemenin kargo firmasına ödenen tahsilat ücreti de burada (sabit ücret olarak) girilir.',
    guideUrl: `${R}#komisyon`,
  },
  'finance_inputs.shipment_cost': {
    kind: 'field',
    title: 'Kargo maliyeti',
    short: "Gönderi için kargo firmasına ödenen tutar (KDV dahil) ve KDV'si; fatura numarasıyla.",
    whatItDoes:
      'Girilen tutar gönderinin gerçek maliyetidir. Girilmemiş gönderiye tahmin kuralı uygulanır ve "tahmini" yazılır; kural da yoksa maliyet bilinmiyor sayılır.',
    guideUrl: `${R}#kargo-maliyeti`,
  },
  'finance_inputs.import': {
    kind: 'action',
    title: 'Kargo faturası yükle',
    short: 'Kargo firmasının fatura dökümünü (CSV/Excel) takip numarasıyla gönderilere eşleştirir.',
    whatItDoes:
      'Önce önizleme gösterilir: hazır, zaten girilmiş ve sorunlu satırlar (takip no bulunamadı, tutar okunamadı, dosyada tekrar eden takip no). Onaylayınca yalnızca hazır satırlar yazılır; istenirse girilmiş tutarlar dosyadakiyle değiştirilir.',
    dataChanged: 'Eşleşen gönderilerin kargo maliyeti.',
    requiredPermission: 'Önizleme: finans raporları. Kaydetme: finans girdilerini yönetme.',
    guideUrl: `${R}#kargo-maliyeti`,
  },
  'finance_inputs.shipping_rule': {
    kind: 'field',
    title: 'Kargo maliyeti tahmin kuralı',
    short: 'Kargo firmasına ve paket ağırlığına göre gönderi başına yaklaşık maliyet (KDV hariç).',
    whatItDoes:
      'Maliyeti girilmemiş gönderi için önce gönderinin firmasına ait, yoksa bütün firmalar için olan kurallardan paket ağırlığının sığdığı en düşük sınırlı kural seçilir; ağırlık bilinmiyorsa sınırsız kural. Çok paketli gönderide paket sayısıyla çarpılır.',
    guideUrl: `${R}#kargo-maliyeti`,
  },
  'finance_inputs.expense': {
    kind: 'field',
    title: 'İşletme gideri',
    short: 'Kira, maaş, yazılım, ambalaj gibi giderler; tutar KDV dahil, KDV ayrıca.',
    whatItDoes:
      'Giderler finans raporunda net kâra ve nakit akışına gider tarihine göre yazılır. Reklam harcaması reklam merkezinden geldiği için burada girilmez.',
    guideUrl: `${R}#giderler`,
  },
  'page.finance_report': {
    kind: 'page',
    title: 'Finans raporu',
    short: 'Dönemin kârlılığı, nakit akışı, KDV özeti, alacaklar; ürün ve kanal kârlılığı.',
    whatItDoes:
      'Kârlılık sipariş esasıdır ve KDV hariçtir: gelir (net satış), satılan malın maliyeti (satış anı maliyeti), kargo gideri, ödeme komisyonu, reklam harcaması ve işletme giderleri. Nakit akışı olayların gerçekleştiği tarihe göredir. Her kalemin yanında verinin tam, kısmen tahmini veya hiç olmadığı yazılır; eksik veri uydurulmaz.',
    whenToUse:
      'Ay sonu kapanışında, fiyat ve kampanya kararlarında, hangi ürün ve kanalın kâr bıraktığını görmek için.',
    requiredPermission: 'Finans raporları (sahip, yönetici, mağaza yöneticisi, finans).',
    reversible: 'Rapor yalnızca okur.',
    commonErrors: [
      {
        problem: 'Brüt kâr çok yüksek görünüyor.',
        solution:
          'Maliyeti girilmemiş ürünlerin satışı kâra maliyetsiz yazılır. "Maliyeti girilmemiş satılan ürünler" listesindeki ürünlerin maliyetini girin.',
      },
      {
        problem: 'Kargo veya komisyon "Veri yok" ya da "Kısmen".',
        solution:
          'Finans girdileri ekranında komisyon kurallarını, kargo maliyetlerini veya tahmin kurallarını girin.',
      },
    ],
    guideUrl: `${R}#finans-raporu`,
  },
  'finance_report.status': {
    kind: 'field',
    title: 'Veri durumu',
    short:
      'Tam: kalemin bütün girdisi var. Kısmen: bir bölümü tahmini veya bilinmiyor. Veri yok: hiç girdi yok (sıfır sayılmaz, eksik olduğu yazılır).',
    guideUrl: `${R}#finans-raporu`,
  },
  'finance_report.cash': {
    kind: 'field',
    title: 'Nakit akışı',
    short:
      'Alınan ödemeler ve bayi tahsilatları (giriş); iadeler, komisyon, kargo ödemeleri, giderler ve reklam (çıkış) — gerçekleştikleri tarihe göre.',
    guideUrl: `${R}#nakit`,
  },
  'finance_report.vat': {
    kind: 'field',
    title: 'KDV özeti',
    short: 'Satışlarda hesaplanan KDV ile giderlerde ve kargoda ödenen KDV. Beyanname yerine geçmez.',
    guideUrl: `${R}#finans-raporu`,
  },
  'finance_report.products': {
    kind: 'field',
    title: 'Ürün ve kanal kârlılığı',
    short:
      'Ürün başına gelir, satılan malın maliyeti ve brüt kâr; kanal başına kargo ve komisyon düşülmüş katkı (reklam hariç).',
    guideUrl: `${R}#finans-raporu`,
  },
  'page.stock_report': {
    kind: 'page',
    title: 'Stok raporu',
    short:
      'Stok değeri, depo ve kategori kırılımı, devir hızı, yavaş hareket eden ürünler; SKT ve kritik stok özeti.',
    whatItDoes:
      'Stok değeri eldeki adedin ürünün güncel maliyetiyle çarpımıdır (KDV hariç). Devir hızı, seçilen dönemde satılan adedin (iadeler düşülür) ortalama stoğa oranıdır; ortalama stok dönem başı ve sonu bakiyesinden, stok hareket defterinden hesaplanır. Yavaş hareket eden ürünler, eldeki adedi olup seçilen süredir satılmayanlardır.',
    whenToUse:
      'Ay sonunda stok değerini görmek, satın alma ve kampanya kararı vermek, bağlanan sermayeyi azaltmak için.',
    requiredPermission: 'Stok görüntüleme. Değer ve maliyet sütunları için maliyet görme yetkisi.',
    reversible: 'Rapor yalnızca okur.',
    commonErrors: [
      {
        problem: 'Stok değeri düşük görünüyor.',
        solution:
          'Maliyeti girilmemiş ürünler değere katılmaz; "maliyetsiz adet" sütununa bakın ve ürün formunda maliyeti girin.',
      },
    ],
    guideUrl: `${R}#stok-raporu`,
  },
  'stock_report.value': {
    kind: 'field',
    title: 'Stok değeri',
    short:
      'Eldeki adet × ürünün güncel maliyeti (KDV hariç). Döviz maliyet son TCMB döviz alış kuruyla TL’ye çevrilir. Maliyeti olmayan ve eksi bakiyeli stok değere katılmaz.',
    guideUrl: `${R}#stok-raporu`,
  },
  'stock_report.turnover': {
    kind: 'field',
    title: 'Devir hızı ve stokta kalma süresi',
    short:
      'Devir hızı = dönemde satılan adet ÷ ortalama stok. Stokta kalma süresi = dönem günü ÷ devir hızı. Yeterlilik: bu satış hızıyla eldeki stoğun kaç gün yeteceği.',
    guideUrl: `${R}#stok-raporu`,
  },
  'stock_report.slow': {
    kind: 'field',
    title: 'Yavaş hareket eden',
    short: 'Eldeki adedi olan ve seçilen süredir (varsayılan 90 gün) hiç satış hareketi olmayan varyant.',
    guideUrl: `${R}#stok-raporu`,
  },
  'stock_report.warehouse': {
    kind: 'field',
    title: 'Depo',
    short: 'Seçilirse bütün rakamlar (bakiye, satış ve devir) yalnızca o deponun hareketlerinden hesaplanır.',
    guideUrl: `${R}#stok-raporu`,
  },
  'page.suppliers': {
    kind: 'page',
    title: 'Tedarikçiler',
    short: 'Mal aldığınız firmalar, cari bakiyeleri ve tedarikçi performansı.',
    whatItDoes:
      'Tedarikçi kartında vade ve teslim süresi tutulur; satın alma siparişi ve tedarikçi cari hesabı tedarikçiye bağlanır. Mal kabulde fatura cariye kendiliğinden yazılır, ödemeler elle girilir. Performans tablosu zamanında teslim, karşılama oranı, eksik/fazla teslim ve teslim süresini gösterir.',
    whenToUse: 'Yeni tedarikçiyle çalışmaya başlarken, ödeme yaparken ve tedarikçileri karşılaştırırken.',
    requiredPermission:
      'Görmek: satın almayı görme. Eklemek: tedarikçi ve satın alma yönetme. Cari kaydı: tedarikçi cari kayıtları.',
    reversible: 'Tedarikçi düzenlenir veya pasife alınır; cari kayıtları silinmez, ters kayıtla düzeltilir.',
    guideUrl: `${P}#tedarikci`,
  },
  'page.supplier': {
    kind: 'page',
    title: 'Tedarikçi',
    short: 'Tedarikçi bilgileri, cari ekstresi ve siparişleri.',
    whatItDoes:
      'Cari ekstresinde artı tutar tedarikçiye borç, eksi tutar ödeme veya alacaktır. Ödemeler en eski vadeli borçtan başlayarak düşülür; vadesi geçmiş kalan "vadesi geçen" olarak yazılır.',
    requiredPermission: 'Satın almayı görme; kayıt eklemek için tedarikçi cari kayıtları.',
    reversible: 'Elle girilen kayıt ters kayıtla düzeltilir; mal kabul faturası düzeltme kaydıyla.',
    guideUrl: `${P}#cari`,
  },
  'page.purchase_orders': {
    kind: 'page',
    title: 'Satın alma',
    short: 'Satın alma talepleri ve tedarikçiye verilen siparişler.',
    whatItDoes:
      'Talep oluşturulur ve düzenlenir; "Sipariş ver" ile tedarikçiye verilmiş sayılır (sistem tedarikçiye ileti göndermez; yazdırıp iletebilirsiniz). Mal geldikçe mal kabul yapılır; tamamı gelince sipariş kendiliğinden "Tamamı alındı" olur, kalan beklenmiyorsa kapatılır.',
    whenToUse: 'Stok azaldığında, kampanya öncesi veya tedarikçiyle anlaşılan alımı kaydetmek için.',
    requiredPermission: 'Görmek: satın almayı görme. Oluşturmak: tedarikçi ve satın alma yönetme.',
    reversible:
      'Mal kabul yapılmamış sipariş iptal edilir; mal kabul geri alınmaz (stok düzeltmesi ve cari düzeltmesiyle).',
    guideUrl: `${P}#satin-alma`,
  },
  'page.purchase_order': {
    kind: 'page',
    title: 'Satın alma siparişi',
    short: 'Satırlar, alınan ve kalan adetler, mal kabuller.',
    whatItDoes:
      'Talep durumunda satırlar düzenlenir. Sipariş verildikten sonra yalnızca beklenen tarih ve not değişir. Mal kabulde stok girişi, tedarikçi faturası ve ürün maliyeti güncellemesi aynı anda yapılır.',
    requiredPermission: 'Satın almayı görme; işlemler için satın alma yönetme veya mal kabul.',
    reversible: 'Bkz. Satın alma.',
    guideUrl: `${P}#satin-alma`,
  },
  'page.purchase_order_new': {
    kind: 'page',
    title: 'Yeni satın alma talebi',
    short: 'Tedarikçi, depo ve ürünlerle satın alma talebi.',
    whatItDoes:
      'Birim maliyet KDV hariç ve siparişin para birimindedir. KDV oranı boş bırakılırsa ürünün vergi sınıfından alınır. Beklenen tarih boşsa tedarikçinin teslim süresinden önerilir.',
    requiredPermission: 'Tedarikçi ve satın alma yönetme.',
    reversible: 'Talep düzenlenir veya iptal edilir.',
    guideUrl: `${P}#satin-alma`,
  },
  'page.goods_receipt': {
    kind: 'page',
    title: 'Mal kabul',
    short: 'Tedarikçiden gelen ürünleri siparişe karşı stoğa alın.',
    whatItDoes:
      'Gelen adet, lot ve son kullanma tarihi girilir; stok defterine giriş yazılır, sipariş satırlarının alınan adedi artar. Maliyetler bu ekranda gösterilmez; tedarikçi faturası ve maliyet güncellemesi siparişteki fiyatlarla yapılır.',
    whenToUse: 'Tedarikçiden mal geldiğinde, irsaliye ile birlikte.',
    requiredPermission: 'Mal kabul.',
    reversible: 'Hayır: hatalı kabul stok düzeltmesi (hasar/düzeltme) ve cari düzeltmesiyle giderilir.',
    guideUrl: `${P}#mal-kabul`,
  },
  'purchasing.code': {
    kind: 'field',
    title: 'Tedarikçi kodu',
    short: 'Kısa ve benzersiz kod (harf, rakam, nokta, tire). Raporlarda ve dosyalarda tedarikçiyi tanımlar.',
    guideUrl: `${P}#tedarikci`,
  },
  'purchasing.payment_terms': {
    kind: 'field',
    title: 'Vade',
    short: 'Mal kabul faturasının vadesi = kabul günü + bu gün sayısı. 0: peşin.',
    guideUrl: `${P}#cari`,
  },
  'purchasing.lead_time': {
    kind: 'field',
    title: 'Teslim süresi',
    short:
      'Siparişten teslime kadar beklenen gün. Yeni siparişte beklenen tarih buradan önerilir; zamanında teslim buna göre ölçülür.',
    guideUrl: `${P}#performans`,
  },
  'purchasing.unit_cost': {
    kind: 'field',
    title: 'Birim maliyet ve KDV',
    short:
      'Birim maliyet KDV hariç ve siparişin para birimindedir. KDV oranı boşsa ürünün vergi sınıfından alınır; fatura ve KDV özeti bu orandan hesaplanır.',
    guideUrl: `${P}#satin-alma`,
  },
  'purchasing.place_order': {
    kind: 'field',
    title: 'Sipariş ver',
    short:
      'Talebi tedarikçiye verilmiş siparişe çevirir. Sistem tedarikçiye ileti göndermez; siparişi yazdırıp veya kendi kanalınızdan iletin.',
    guideUrl: `${P}#satin-alma`,
  },
  'purchasing.receive': {
    kind: 'field',
    title: 'Mal kabul',
    short:
      'Gelen adet kalan adetten fazla olamaz (fazla teslim ayrıca onaylanır). Lotlu üründe lot numarası ve SKT girilir; aynı lot farklı SKT ile girilemez.',
    guideUrl: `${P}#mal-kabul`,
  },
  'purchasing.update_cost': {
    kind: 'field',
    title: 'Maliyet güncelleme',
    short:
      'Ürün maliyeti = (eldeki adet × mevcut maliyet + gelen adet × alış maliyeti) ÷ toplam adet. Maliyeti yoksa alış maliyeti yazılır; ürün maliyeti başka para birimindeyse değişmez.',
    guideUrl: `${P}#maliyet`,
  },
  'purchasing.ledger_entry': {
    kind: 'field',
    title: 'Cari kaydı',
    short:
      'Ödeme ve iade borcu azaltır, açılış borç yazar, düzeltme açıklamayla iki yönde de girilir. Kayıt silinmez; yanlış kayıt ters kayıtla düzeltilir.',
    guideUrl: `${P}#cari`,
  },
  'purchasing.performance': {
    kind: 'field',
    title: 'Tedarikçi performansı',
    short:
      'Zamanında teslim: son mal kabulü beklenen tarihte veya önce olan tamamlanmış siparişler. Karşılama: alınan ÷ sipariş edilen adet (fazlası sayılmaz).',
    guideUrl: `${P}#performans`,
  },
  'page.report_builder': {
    kind: 'page',
    title: 'Rapor oluşturucu',
    short:
      'Veri kümesi, metrik ve boyut seçerek kendi raporunuzu oluşturun; pivot tablo, grafik, kaydetme ve paylaşma.',
    whatItDoes:
      'Siparişler, ürün satışları veya stok üzerinden en çok 4 metrik ve 2 satır boyutu seçilir; sütun boyutu seçilirse tablo pivot olur (tek metrik). Tanımlar satış, finans ve stok raporlarıyla aynıdır. SQL yazılmaz; yalnızca listedeki seçenekler kullanılır. Rapor kaydedilip rollere veya kişilere paylaşılabilir; paylaşılan kişi veriyi kendi yetkileriyle görür.',
    whenToUse:
      'Hazır raporlarda olmayan bir kırılım gerektiğinde (ör. markaya göre aylık brüt kâr, şehre göre sipariş).',
    requiredPermission:
      'Çalıştırmak: özel raporlar + ilgili veri yetkisi (satış raporu veya stok). Kaydetmek ve paylaşmak: özel rapor kaydetme.',
    reversible: 'Rapor yalnızca okur; kayıtlı rapor düzenlenir veya silinir.',
    guideUrl: `${R}#rapor-olusturucu`,
  },
  'report_builder.metrics': {
    kind: 'field',
    title: 'Metrikler ve boyutlar',
    short:
      'Metrik toplanan değerdir (net satış, adet…); boyut gruplamadır (ay, ürün, kanal…). Ortalama sepet ve brüt marj toplamlardan hesaplanır.',
    guideUrl: `${R}#rapor-olusturucu`,
  },
  'report_builder.pivot': {
    kind: 'field',
    title: 'Pivot tablo',
    short:
      'Sütun boyutu seçilince her değer bir sütun olur (ör. satırda ürün, sütunda ay); tek metrik gösterilir, en çok 36 sütun.',
    guideUrl: `${R}#rapor-olusturucu`,
  },
  'report_builder.share': {
    kind: 'field',
    title: 'Paylaşım',
    short:
      'Rapor rollere veya kişilere paylaşılır; yalnızca sahibi düzenler. Paylaşılan kişi veriyi kendi yetkileriyle görür (maliyet ve mağaza kapsamı).',
    guideUrl: `${R}#rapor-olusturucu`,
  },
  'dashboard.widgets': {
    kind: 'field',
    title: 'Rapor bileşenleri',
    short:
      'Kayıtlı raporlarınızı ana panelde tablo, grafik veya yalnızca toplam olarak görün. Bileşenler kişiseldir; rapor her açılışta sizin yetkilerinizle çalışır. En çok 12 bileşen.',
    guideUrl: `${R}#pano`,
  },
  'reports.print': {
    kind: 'action',
    title: 'Yazdır / PDF',
    short:
      'Ekrandaki raporu tarayıcının yazdırma penceresiyle yazdırır; hedef olarak "PDF olarak kaydet" seçilirse PDF dosyası oluşur. Menü ve düğmeler kâğıda basılmaz.',
    dataChanged: 'Hiçbir veri değişmez.',
    guideUrl: `${R}#yazdir`,
  },
  'page.report_files': {
    kind: 'page',
    title: 'Rapor dosyalarım',
    short:
      'Arka planda hazırlanan büyük rapor dosyalarınız ve zamanlanmış raporlar; dosyalar 30 gün saklanır.',
    whatItDoes:
      'Rapor oluşturucudan istenen büyük raporlar (en çok 50.000 satır) burada hazırlanır ve indirilir. Zamanlanmış raporlar günlük, haftalık veya aylık olarak önceki tam dönem için üretilir; alıcıya e-postayla yalnızca bu sayfanın bağlantısı gider, rapor verisi gitmez. Her dosya sahibinin yetkileriyle üretilir ve yalnızca ona görünür.',
    whenToUse:
      'Ekranda gösterilenden çok satırlı bir döküm gerektiğinde veya bir raporun her hafta/ay belirli kişilere hazır olmasını istediğinizde.',
    requiredPermission:
      'Dosyalar: özel raporlar. Zamanlama kurmak: zamanlanmış rapor yetkisi (mağaza yöneticisi ve finans rolünde).',
    reversible: 'Zamanlama kapatılır veya silinir; üretilmiş dosyalar 30 gün sonra kendiliğinden silinir.',
    commonErrors: [
      {
        problem: 'Alıcıya e-posta gitmedi.',
        solution:
          'Alıcı raporu göremiyorsa (rapor onunla paylaşılmadıysa veya veri yetkisi yoksa) atlanır. Raporu alıcıya veya rolüne paylaşın; son gönderim sütununda atlanan sayısını görürsünüz.',
      },
      {
        problem: 'Dosya "Hazırlanamadı" durumunda.',
        solution:
          'Yetkiniz değiştiyse veya dosya 20 MB sınırını aştıysa üretilmez. Süzgeç ekleyip yeniden isteyin.',
      },
    ],
    guideUrl: `${R}#rapor-dosyalari`,
  },
  'report_files.background': {
    kind: 'action',
    title: 'Arka planda hazırla',
    short:
      'Raporu en çok 50.000 satırla arka planda dosyaya çevirir; hazır olunca "Rapor dosyalarım" sayfasından indirirsiniz. Ekrandaki satır sınırı uygulanmaz.',
    dataChanged: 'Rapor verisi değişmez; yalnızca size ait bir dosya oluşur (30 gün saklanır).',
    requiredPermission: 'Özel raporlar ve raporun veri yetkisi.',
    guideUrl: `${R}#rapor-dosyalari`,
  },
  'report_files.schedule': {
    kind: 'field',
    title: 'Zamanlanmış rapor',
    short:
      'Kayıtlı rapor günlük (önceki gün), haftalık (önceki pazartesi–pazar) veya aylık (önceki ay) olarak, seçtiğiniz saatte (Türkiye) üretilir. Aynı dönem iki kez gönderilmez.',
    whatItDoes:
      'Raporun kendi dönem seçimi yerine zamanlamanın dönemi kullanılır (stok raporunda o anki stok). Yeni zamanlama kapalı kaydedilir; gönderimi açtığınızda başlar.',
    requiredPermission: 'Zamanlanmış rapor yetkisi; rapor size görünür olmalı.',
    guideUrl: `${R}#zamanlanmis-rapor`,
  },
  'report_files.recipients': {
    kind: 'field',
    title: 'Alıcılar',
    short:
      'Yalnızca işletme üyeleri seçilebilir (en çok 20). Her alıcının dosyası kendi yetkileriyle üretilir; raporu göremeyen alıcı atlanır. E-postada yalnızca bağlantı olur.',
    guideUrl: `${R}#zamanlanmis-rapor`,
  },
  'report_files.enabled': {
    kind: 'field',
    title: 'Gönderim açık',
    short: 'Kapalı zamanlama çalışmaz. Açtığınızda sonraki gönderim zamanı yeniden hesaplanır.',
    guideUrl: `${R}#zamanlanmis-rapor`,
  },
  'page.payment_disputes': {
    kind: 'page',
    title: 'Ödeme itirazları',
    short:
      'Bankanın veya ödeme kuruluşunun bildirdiği ters ibraz (chargeback) ve bilgi taleplerinin kaydı; durum, yanıt süresi, belge ve finans raporuna etkisi.',
    whatItDoes:
      'Kart sahibi bankasına başvurup işleme itiraz ettiğinde ödeme kuruluşu tutarı geri alabilir. Bu sayfa itirazı siparişin ödemesine bağlı olarak kaydeder, yanıt son gününü izler, gönderdiğiniz belgeleri ve sonucu saklar. Kaybedilen veya kabul edilen tutar ile itiraz ücreti finans raporunda kârdan ve nakitten düşülür; açık itirazlar risk altındaki tutar olarak görünür. Sistem bankaya veya ödeme kuruluşuna bir şey göndermez.',
    whenToUse: 'Ödeme kuruluşundan itiraz bildirimi (e-posta veya panel) geldiğinde, aynı gün.',
    requiredPermission:
      'Görmek: ödemeleri görme. Kayıt ve durum: ödeme itirazı yönetimi (mağaza yöneticisi, finans).',
    reversible:
      'Kayıt silinmez; tutar ve tarihler düzeltilebilir, kapanan itiraz gerekçeyle yeniden açılabilir. Her değişiklik geçmişte görünür.',
    commonErrors: [
      {
        problem: 'Siparişte ödeme bulunamadı.',
        solution:
          'İtiraz yalnızca kartla (iyzico, PayTR) veya fiziki POS ile alınmış ve tahsil edilmiş ödemeye açılır; havale ve kapıda ödeme itiraz konusu olmaz.',
      },
    ],
    guideUrl: `${R}#odeme-itirazlari`,
  },
  'page.payment_dispute': {
    kind: 'page',
    title: 'Ödeme itirazı',
    short: 'İtirazın bilgileri, durumu, belgeleri, notları ve değişiklik geçmişi.',
    whatItDoes:
      'Durum düğmeleri itirazı ilerletir (belge gönderildi, kazanıldı, kaybedildi, kabul); kapanışta kapanış tarihi girilir. Belgeler özel dosya olarak eklenir ve yalnızca panelde indirilir. Notlar ve bütün değişiklikler geçmişte kalır, silinmez. Kaybedilen tutar finans raporuna yansır.',
    guideUrl: `${R}#odeme-itirazlari`,
  },
  'disputes.status': {
    kind: 'field',
    title: 'İtiraz durumu',
    short:
      'Açık → Belge gönderildi → Kazanıldı veya Kaybedildi. "Kabul edildi": itiraz edilmeden tutar bırakıldı. Kaybedilen ve kabul edilen tutar finans raporunda kârdan ve nakitten düşülür.',
    guideUrl: `${R}#odeme-itirazlari`,
  },
  'disputes.amount': {
    kind: 'field',
    title: 'İtiraz tutarı ve ücreti',
    short:
      'Tutar, ödemenin itirazda olmayan kısmını aşamaz. Ücret, bankanın veya kuruluşun sonuçtan bağımsız aldığı itiraz ücretidir; kârlılıkta her durumda, nakitte kapanışta düşülür.',
    guideUrl: `${R}#odeme-itirazlari`,
  },
  'disputes.documents': {
    kind: 'action',
    title: 'Belge ekle',
    short:
      'Fatura, kargo teslim belgesi, yazışma gibi itiraz belgelerini (PDF, JPEG, PNG; 10 MB) kayda ekler. Belgeler özel dosyadır; vitrinde görünmez.',
    dataChanged: 'İtirazın geçmişine belge eklenir.',
    guideUrl: `${R}#odeme-itirazlari`,
  },
  'page.price_simulation': {
    kind: 'page',
    title: 'Fiyat simülasyonu',
    short:
      'Fiyat, maliyet veya komisyon değişirse ürün başına ve dönem toplamında komisyon sonrası kârın ne olacağını hesaplar; fiyatları değiştirmez.',
    whatItDoes:
      'Seçilen TL fiyat listesindeki ürünler için KDV hariç fiyat, maliyet, komisyon ve birim katkıyı mevcut ve senaryo olarak yan yana gösterir. Komisyon, dönemde alınan ödemelerin kurallarla hesaplanan etkin oranıdır (elle de girilebilir). Dönem etkisi, son 30/90/365 günde satılan adetle çarpılarak bulunur; adedin fiyattan etkilenmediği varsayılır. Zararda kalan ve en düşük marjın altındaki ürünler önce listelenir.',
    whenToUse: 'Zam, indirim veya tedarikçi maliyet artışı öncesinde; ödeme kuruluşu oranı değiştiğinde.',
    requiredPermission: 'Maliyet görme ve fiyat görme; satış adedi için satış raporu.',
    reversible:
      'Hiçbir veriyi değiştirmez. Fiyatları uygulamak için toplu fiyat düzenleme kullanılır (önizleme ve geri alma orada).',
    guideUrl: `${R}#fiyat-simulasyonu`,
  },
  'price_simulation.scenario': {
    kind: 'field',
    title: 'Senaryo',
    short:
      'Fiyat ve maliyet yüzde olarak değiştirilir (ör. 10 zam, -5 indirim). KDV dahil listede KDV hariç fiyat ürünün KDV oranıyla bulunur.',
    guideUrl: `${R}#fiyat-simulasyonu`,
  },
  'price_simulation.fee': {
    kind: 'field',
    title: 'Komisyon oranı',
    short:
      'Boş bırakılırsa dönemde alınan ödemelerin etkin komisyon oranı (finans girdilerindeki kurallarla, ödeme yöntemi karışımı dahil) kullanılır.',
    guideUrl: `${R}#fiyat-simulasyonu`,
  },
  'price_simulation.volume': {
    kind: 'field',
    title: 'Satış adedi dönemi',
    short:
      'Dönem etkisi için listenin mağazasında bugün dahil son 30, 90 veya 365 günde satılan adet (iptal düşülür).',
    guideUrl: `${R}#fiyat-simulasyonu`,
  },
  'page.marketing_summary': {
    kind: 'page',
    title: 'Pazarlama ve SEO özeti',
    short:
      'Vitrin hunisi, yeni müşteri ve edinme maliyeti (CAC), 12 aylık müşteri değeri, reklam, organik arama, e-posta/SMS ve siparişlerin kaynağı tek sayfada.',
    whatItDoes:
      'Sistemdeki kayıtlardan özet çıkarır: sepete ürün eklenen sepetler, vitrinde oluşturulan siparişler ve kesinleşen siparişler (satış raporu tanımı); yeni müşteri ve reklam harcamasından CAC; son 12 ayın müşteri başı net satışı; eşitlenmiş reklam ve Search Console verisi; kampanya gönderimleri; siparişlerin son dokunuş kaynağı. Ayrıntı için ilgili rapora bağlantı verir. Dış servise istek göndermez.',
    whenToUse: 'Haftalık veya aylık pazarlama değerlendirmesinde; kampanya sonrası.',
    requiredPermission:
      'Satış raporları. Reklam, SEO, kampanya ve ölçüm bölümleri kendi yetkileriyle görünür.',
    reversible: 'Rapor yalnızca okur.',
    guideUrl: `${R}#pazarlama-ozeti`,
  },
  'marketing_summary.funnel': {
    kind: 'field',
    title: 'Vitrin hunisi',
    short:
      'Sepete ürün eklendi → sipariş adımı (vitrinde oluşturulan sipariş, ödeme bekleyen dahil) → kesinleşen sipariş. Görüntüleme sunucuda tutulmadığı için huniye eklenmez.',
    guideUrl: `${R}#pazarlama-ozeti`,
  },
  'marketing_summary.cac': {
    kind: 'field',
    title: 'Yeni müşteri başı reklam maliyeti (CAC)',
    short:
      'Dönemin bütün reklam harcaması ÷ dönemin yeni müşterisi (kesinleşmiş ilk siparişi bu dönemde olan). Reklamdan gelmeyen yeni müşteriler de paydadadır.',
    guideUrl: `${R}#pazarlama-ozeti`,
  },
  'marketing_summary.value': {
    kind: 'field',
    title: '12 aylık müşteri değeri',
    short:
      'Son 365 günün net satışı (KDV dahil, iade ve iptal düşülmüş) ÷ bu sürede alışveriş yapan müşteri. Geçmişe dönüktür; gelecek tahmini (LTV modeli) değildir.',
    guideUrl: `${R}#pazarlama-ozeti`,
  },
  'marketing_summary.sources': {
    kind: 'field',
    title: 'Son dokunuş kaynağı',
    short:
      'Vitrin siparişinin son kampanya/kaynak bilgisi (UTM). Çerez izni olmayan siparişlerin kaynağı bilinemez ve ayrı gösterilir.',
    guideUrl: `${R}#pazarlama-ozeti`,
  },
  'page.multi_touch': {
    kind: 'page',
    title: 'Çok dokunuşlu atribüsyon',
    short:
      'Kesinleşen vitrin siparişlerini ilk temas, son temas, doğrusal ve konuma göre (U) modelle kaynaklara dağıtır; dört model yan yana.',
    whatItDoes:
      'Ziyaretçinin siparişe kadar geldiği kaynaklar (UTM, arama motoru, sosyal ağ, yönlendiren site) çerez izniyle kaydedilir: ilk temas, ara temaslar (en çok 5) ve son temas. Sipariş ve net satış bu temaslara modele göre paylaştırılır. Çerez izni olmayan siparişin kaynağı bilinemez ve ayrı satırdadır.',
    whenToUse:
      'Bir kanalın yalnızca son tıklamada değil, yolculuğun başında veya ortasında ne kadar katkı verdiğini görmek için (ör. bülten ilk teması, reklam son teması).',
    requiredPermission: 'Ölçüm raporları.',
    reversible: 'Rapor yalnızca okur.',
    guideUrl: `${R}#coklu-dokunus`,
  },
  'multi_touch.models': {
    kind: 'field',
    title: 'Atribüsyon modelleri',
    short:
      'İlk/son temas: siparişin tamamı o temasa. Doğrusal: her temasa eşit. Konuma göre (U): ilk ve son temasa %40, ara temaslara toplam %20.',
    guideUrl: `${R}#coklu-dokunus`,
  },
  // ------------------------------------------------------------------ Otomasyon kurucusu (F8-15)
  'page.workflows': {
    kind: 'page',
    title: 'Otomasyon akışları',
    short:
      'Tetikleyici → Koşul → Eylem: bir olay olunca koşullara bakıp eylemleri kendiliğinden yapan akışlar.',
    whatItDoes:
      'Akışlarınızı, durumlarını ve son 7 günün çalışma sayılarını listeler; 10 hazır örnekten taslak oluşturur. Akış açıldığı andan sonraki olayları işler (geçmişe dönük çalışmaz). Eylemler akışı açan kişinin güncel yetkisiyle çalışır; aynı olay bir akışta yalnızca bir kez işlenir. Geçici hatalar 1 dk, 5 dk, 30 dk ve 2 saat arayla yeniden denenir; her adım kayda geçer. Müşteriye ileti (sepet hatırlatma, stok bildirimi) burada kurulmaz; izin ve İYS denetimli kendi bölümlerindedir.',
    whenToUse:
      'Tekrarlayan işleri (ödenen siparişi hazırlığa alma, kritik stok uyarısı, haftalık rapor, SSL uyarısı) elle takip etmek yerine kendiliğinden yaptırmak için.',
    dataChanged:
      'Liste yalnızca gösterir. "Tümünü durdur" açık bütün akışları durdurur ve bekleyen çalışmaları iptal eder.',
    requiredPermission:
      'Görmek: otomasyon akışlarını görme. Oluşturmak ve açmak: otomasyon akışı yönetme (iki adımlı doğrulama).',
    reversible: 'Durdurulan akış yeniden açılabilir; durdurulduğu sürede olan olaylar işlenmez.',
    guideUrl: `${R}#otomasyon-akislari`,
  },
  'page.workflow': {
    kind: 'page',
    title: 'Otomasyon akışı',
    short: 'Akışın tetikleyicisi, koşulları ve eylemleri; deneme, açma/durdurma ve çalışma kaydı.',
    whatItDoes:
      'Üç adımda akışı kurarsınız: 1) Ne olduğunda (tetikleyici), 2) Hangi koşullarda (alan + karşılaştırma + değer; hepsi veya biri), 3) Ne yapılsın (eylemler sırayla). "Son olaylarla dene" kaydetmeden koşulları gerçek son olaylarla değerlendirir; hiçbir eylem çalışmaz. Açmadan önce giderilmesi gerekenler (eksik seçim, yetki, uyumsuz eylem) sayfanın başında listelenir.',
    whenToUse:
      'Yeni akış kurarken, hazır örneği kendinize göre ayarlarken veya bir çalışmanın neden atlandığını anlamak için.',
    dataChanged:
      'Kaydet tanımı değiştirir (açık akışta yeni olaylara uygulanır ve akış bundan sonra sizin adınıza çalışır). Aç/Durdur/Arşivle durumu değiştirir; arşivlenen akış silinmez, çalışma kaydı korunur.',
    requiredPermission:
      'Otomasyon akışı yönetme ve her eylemin kendi yetkisi (ör. sipariş eylemi için sipariş düzenleme).',
    reversible:
      'Durdurma geri alınır; arşiv geri alınmaz. Eylemlerin etkisi (gönderilen e-posta, yayımlanan yazı) geri alınmaz.',
    commonErrors: [
      {
        problem: 'Aç düğmesi pasif.',
        solution:
          'Kaydedilmemiş değişikliği kaydedin ve "Akışı açmadan önce giderin" listesindeki maddeleri düzeltin.',
      },
      {
        problem: 'Akış kendiliğinden durdu.',
        solution:
          'Nedeni sayfanın başında yazar: saatlik sınır aşıldıysa koşulları daraltın veya sınırı artırın; açan kişinin üyeliği/yetkisi değiştiyse yetkili biri yeniden açsın.',
      },
    ],
    guideUrl: `${R}#otomasyon-akislari`,
  },
  'page.workflow_run': {
    kind: 'page',
    title: 'Otomasyon çalışması',
    short: 'Bir olayın akışta nasıl işlendiği: olay alanları, koşul sonuçları ve her eylem denemesi.',
    whatItDoes:
      'Olayın alanlarını, her koşulun tutup tutmadığını ve adım kaydını (eylem, deneme, sonuç, ayrıntı) gösterir. Başarısız çalışma kaldığı eylemden yeniden denenebilir (tamamlanan eylemler tekrar çalışmaz); bekleyen çalışma iptal edilebilir. Adım kaydı değiştirilemez ve silinemez.',
    whenToUse: 'Bildirim e-postasındaki bağlantıdan veya bir akışın neden başarısız olduğunu incelerken.',
    dataChanged: 'Yeniden dene çalışmayı sıraya alır; İptal bekleyen çalışmayı kapatır.',
    requiredPermission:
      'Görmek: otomasyon akışlarını görme. Yeniden deneme ve iptal: otomasyon akışı yönetme.',
    reversible: 'İptal geri alınmaz; olay yeniden işlenmez.',
    guideUrl: `${R}#otomasyon-akislari`,
  },
  'workflows.templates': {
    kind: 'field',
    title: 'Hazır örnekler',
    short:
      '10 örnek akış: 8 tanesi burada taslak olarak açılır, seçimleri (mağaza, rapor, alıcı) yapıp açarsınız; müşteriye ileti gönderen 2 örnek kendi bölümlerinde çalışır.',
    guideUrl: `${R}#otomasyon-akislari`,
  },
  'workflows.linked': {
    kind: 'field',
    title: 'Müşteri iletisi örnekleri',
    short:
      'Sepet hatırlatma ve stok bildirimi müşteriye gider; pazarlama izni, İYS, engel listesi ve sıklık sınırı için kendi bölümlerinde yönetilir. Durum (açık/kapalı) o bölümden okunur.',
    guideUrl: `${R}#otomasyon-akislari`,
  },
  'workflows.trigger': {
    kind: 'field',
    title: 'Tetikleyici',
    short:
      'Akışı başlatan olay. Olaylar dakikada bir alınır; akış açılmadan önce olanlar işlenmez, aynı olay iki kez işlenmez.',
    guideUrl: `${R}#otomasyon-akislari`,
  },
  'workflows.conditions': {
    kind: 'field',
    title: 'Koşullar',
    short:
      'Olayın alanlarıyla karşılaştırma (en çok 10). Tutmayan olay "atlandı" diye kaydedilir; metin karşılaştırması büyük/küçük harfe duyarsızdır, tutar TL ile girilir.',
    guideUrl: `${R}#otomasyon-akislari`,
  },
  'workflows.actions': {
    kind: 'field',
    title: 'Eylemler',
    short:
      'Sırayla çalışır (en çok 8). "Atlandı" (iş yok veya kurulum gerekli) sonrakini engellemez; SEO kontrolü sorun bulursa sonrakileri durdurabilir. Eylem, akışı açan kişinin yetkisiyle çalışır.',
    guideUrl: `${R}#otomasyon-akislari`,
  },
  'workflows.recipients': {
    kind: 'field',
    title: 'Bildirim alıcıları',
    short:
      'Yalnızca panel üyeleri (en çok 20). "Yetkiye göre" seçimde gönderim anındaki yetkiye bakılır; mağazalı olayda kişinin mağaza kapsamı da denetlenir.',
    guideUrl: `${R}#otomasyon-akislari`,
  },
  'workflows.limits': {
    kind: 'field',
    title: 'Sınırlar',
    short:
      'Bekleme: bir çalışmadan sonra bu süre içindeki olaylar atlanır. Saatlik sınır aşılırsa akış kendiliğinden durur ve yöneticilere e-posta gider (döngü koruması).',
    guideUrl: `${R}#otomasyon-akislari`,
  },
  'workflows.test': {
    kind: 'action',
    title: 'Son olaylarla dene',
    short:
      'Kaydetmeden, tetikleyicinin son 5 olayıyla koşulları değerlendirir. Eylem çalışmaz, kayıt değişmez.',
    guideUrl: `${R}#otomasyon-akislari`,
  },
  'workflows.pause_all': {
    kind: 'action',
    title: 'Tümünü durdur',
    short:
      'Acil durdurma: açık bütün akışlar durur, bekleyen çalışmalar iptal edilir. Akışları tek tek yeniden açarsınız.',
    whenToUse:
      'Bir otomasyon akışı beklenmedik işler yapıyorsa (yanlış e-posta, hatalı durum değişikliği) ve hepsini hemen durdurmak istediğinizde.',
    dataChanged:
      'Açık bütün akışlar "durduruldu" olur ve bekleyen çalışmaları iptal edilir; durdurulan akış ve iptal edilen çalışma sayısı denetim kaydına yazılır.',
    requiredPermission:
      'Otomasyon akışı oluşturma, açma/durdurma ve yeniden deneme (hassas; iki adımlı doğrulama).',
    reversible: 'Kısmen: akışlar tek tek yeniden açılabilir; iptal edilen çalışmalar geri gelmez.',
    commonErrors: [
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
    ],
    guideUrl: `${R}#otomasyon-akislari`,
  },
  'workflows.run_as': {
    kind: 'field',
    title: 'Akışı açan kişi',
    short:
      'Eylemler bu kişinin GÜNCEL yetkileriyle çalışır. Üyeliği kapanır veya gereken yetkisi düşerse akış kendiliğinden durur. Açık akışı değiştiren kişi akışın yeni sahibi olur.',
    guideUrl: `${R}#otomasyon-akislari`,
  },
  'workflows.runs': {
    kind: 'field',
    title: 'Çalışma kaydı',
    short:
      'Her olay bir çalışma: bekliyor, çalışıyor, başarılı, başarısız, atlandı (koşul, bekleme süresi, mağaza kapsamı) veya iptal. Ayrıntıda her eylem denemesi görünür.',
    guideUrl: `${R}#otomasyon-akislari`,
  },
  'workflows.retry': {
    kind: 'action',
    title: 'Yeniden dene ve iptal',
    short:
      'Başarısız çalışma kaldığı eylemden yeniden denenir (akış açık olmalı); bekleyen çalışma iptal edilebilir. Belirsiz e-fatura gönderimi yeniden denenmeden önce Faturalar sayfasında kontrol edin.',
    guideUrl: `${R}#otomasyon-akislari`,
  },
} satisfies Record<string, HelpContent>;
